import { useEffect, useRef, useState } from "react";
import "../../styles/main.scss";
import { registerMenuCloser } from "../../services/menuManager";
import { SelectProps } from "./Select/types";

export default function Select({
  options,
  value,
  isChangeable = true,
  classes,
  placeholder,
  onChange,
  setValue,
  formName,
  calendar,
  disabled = false, // новый проп
}: SelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(value);
  const selectRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (
        selectRef.current &&
        !selectRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const chooseOption = (option: any) => {
    setSelectedOption(option);

    if (onChange) {
      onChange(option);
    }

    if (setValue && formName) {
      setValue(formName, option, { shouldDirty: true });
    }
  };

  return (
    <div
      ref={selectRef}
      className={`select ${classes?.select || ""} ${disabled ? "select--disabled" : ""}`}
      style={disabled ? { opacity: 0.3, pointerEvents: "none" } : undefined}
    >
      <div
        className={`select_wrapper ${classes?.select_wrapper || ""}`}
        onClick={() => {
          if (disabled) return; // дополнительная защита
          setIsOpen((prev) => !prev);
        }}
      >
        {selectedOption ? (
          <div className={`select_value ${classes?.select_value || ""}`}>
            {selectedOption}
          </div>
        ) : (
          <div className={`select_placeholder ${classes?.select_placeholder || ""}`}>
            {placeholder}
          </div>
        )}

        <div
          className={`
            select_arrow ${isOpen ? "opened" : "closed"}
            ${classes?.select_arrow || ""}
          `}
        />
      </div>

      <div
        className={`
          ${calendar ? "select_calendar-window" : "select_options"}
          ${isOpen ? "visible" : "hidden"}
          ${classes?.select_options || ""}
        `}
      >
        {(() => {
          if (options?.length > 0) {
            return options.map((option, idx) =>
              isChangeable ? (
                <div
                  className={`select_option ${classes?.select_option || ""} ${
                    selectedOption === option ? "selected" : ""
                  }`}
                  key={`option ${option?.toString()}-${idx}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (disabled) return; // блокировка выбора
                    setIsOpen(false);
                    if (selectedOption !== option) {
                      chooseOption(option);
                    }
                  }}
                >
                  {option}
                </div>
              ) : (
                <div key={`option ${idx}`}>{option}</div>
              )
            );
          }
          return (
            <p
              className={`select_option ${classes?.select_option || ""} selected`}
            >
              Нет доступных вариантов для выбора
            </p>
          );
        })()}
      </div>
    </div>
  );
}